import { create } from 'zustand';

import type { CryptoOperation } from 'models/crypto';

interface CryptoCitizenshipDialogState {
    isOpen: boolean;
    accountName: string;
    callbackOperation: CryptoOperation;
    actions: {
        open: () => void;
        close: () => void;
        setAccountName: (value: string) => void;
        setCallbackOperation: (value: CryptoOperation) => void;
    };
}

export const useCryptoCitizenshipDialogStore = create<CryptoCitizenshipDialogState>()((set) => ({
    isOpen: false,
    accountName: '',
    callbackOperation: 'deposit',
    actions: {
        open: () => set({ isOpen: true }),
        close: () => set({ isOpen: false }),
        setAccountName: (value) => set({ accountName: value }),
        setCallbackOperation: (value) => set({ callbackOperation: value }),
    },
}));
